import { Button, IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const OutlinedButton = muiStyled(Button)({
  border: '2px solid #fff',
  color: '#fff',
  '&:hover': {
    border: '2px solid #fff',
  },
});

export const OutlinedIconButton = muiStyled(IconButton)({
  border: '2px solid #fff',
  borderRadius: '4px',
  padding: '4px',
  marginLeft: '10px',
});

export const VerticalDivider = muiStyled('div')({
  position: 'relative',
  marginLeft: '15px',
  marginRight: '15px',
  '::after': {
    content: '""',
    position: 'absolute',
    color: '#fff',
    backgroundColor: '#fff',
    height: '28px',
    width: '2px',
    top: '2px',
    left: '4px',
  },
});
